'use strict';exports.__esModule = true;var _rtlDetect = require('rtl-detect');

var isRtlLanguage = function isRtlLanguage(locale) {return (0, _rtlDetect.isRtlLang)(locale);};exports.default =

isRtlLanguage;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/checkRtlLanguage.js
// module id = 27
// module chunks = 0